'use strict';

var App = require('app');
var MenubarController = require('components/menubar/menubar_controller');

var MenubarComponent = {};

App.on('menubar:change', function (entryParams) {
    MenubarController.showMenubar(entryParams);
});

App.on('menubar:statusChanged', function (status) {
    MenubarController.changeStatus(status);
});

module.exports = MenubarComponent;
